import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import { name as validatorServiceName, EvaluationTypes, } from '../validation/validatorService';
import { transformValidationSchema } from '../validation/validationRulesAdaptor';
import ValidationRuleSet from '../validation/validationRuleSet';
let validator;
const parseEvaluationRules = (evaluationRules, parentElement) => {
    if (!evaluationRules) {
        return [];
    }
    const rules = [];
    for (const [elementId, ruleSet] of Object.entries(evaluationRules)) {
        const newRuleSet = new ValidationRuleSet(elementId, ruleSet, parentElement);
        rules.push(newRuleSet);
    }
    return rules;
};
const validateRuleSets = async (ruleSets) => {
    const errors = new Map();
    if (typeof validator === 'undefined') {
        validator = Injector.get(validatorServiceName, InjectorScope.Singleton);
    }
    for (const ruleSet of ruleSets) {
        const result = await validator.validate(ruleSet); // eslint-disable-line no-await-in-loop
        // There are errors
        if (result !== true) {
            errors.set(ruleSet.elementId, result);
        }
    }
    return errors.size > 0 ? errors : true;
};
export function validatable(Class) {
    const { prototype } = Class;
    prototype.setValidationRules = function setValidationRules(options) {
        // Transform options passed to component (ex. this.options), and shape them so they can be parsed
        const parsedValidationRules = transformValidationSchema(options);
        // Parse rules individually
        this.eagerRules = parseEvaluationRules(parsedValidationRules[EvaluationTypes.eager], this.element);
        this.lazyRules = parseEvaluationRules(parsedValidationRules[EvaluationTypes.lazy], this.element);
        this.allRules = parseEvaluationRules(parsedValidationRules[EvaluationTypes.allRules], this.element);
    };
    prototype.validateEvaluationRules = async function validateEagerRules(type, event) {
        // Eager validation requires an event.target to bind to, if it isn't passed in log an error
        if (type === EvaluationTypes.eager) {
            if (!event) {
                Logger.error('You must specify a target element to evaluate against with eager evaluation');
            }
            const { target } = event;
            /**
             * Gets all of the rule sets for targetElement for eager evaluation
             * Protects against the case in which someone sets multiple ruleSets for the same element
             */
            const eagerRuleSet = this.eagerRules.filter(ruleSet => ruleSet.elementId === target.id);
            if (!eagerRuleSet) {
                Logger.error(`There are no eager rules set on element ${eagerRuleSet}`);
            }
            const validatedRuleSet = await validateRuleSets(eagerRuleSet);
            return validatedRuleSet;
        }
        // Lazy validation does not require a target element to bind to, just return the ruleset
        if (type === EvaluationTypes.lazy) {
            const validatedRuleSet = await validateRuleSets(this.lazyRules);
            return validatedRuleSet;
        }
        // Return array of rulesets, eager, lazy, or both
        const validatedRuleSet = await validateRuleSets(this.allRules);
        return validatedRuleSet;
    };
    return Class;
}
